import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserService } from '@ml/core/services';
import { UserRole } from '@ml/core/types/enums';
import { MediaObserver } from '@angular/flex-layout';
import { first, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdminPhoneGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService,
    private mediaObserver: MediaObserver
  ) {}

  /**
   * If the admin in on phone, redirect to tasks page
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    const user = this.userService.user;
    if (user.role !== UserRole.ADMIN) {
      this.router.navigate(['orders']);
      return true;
    }

    return this.mediaObserver.asObservable().pipe(
      first(),
      map(() => {
        if (this.mediaObserver.isActive('lg')) {
          this.router.navigate(['orders']);
          return true;
        }
        this.router.navigate(['tasks']);
        return false;
      })
    );
  }
}
